import { useState } from "react";
import PageHeader from "../../Component/Common/PageHeader";
import MultiButton from "../../Component/extra/MultiButton";
import SoundCategory from "./SoundCategory";
import SoundList from "./SoundList";

export default function SoundPage() {
  const [multiButtonSelect, setMultiButtonSelect] = useState("Sound List");

  return (
    <div className="userPage channelPage">
      <PageHeader heading="Welcome Admin" subHeading="Sound" />

      <MultiButton
        label={["Sound List", "Sound Category"]}
        multiButtonSelect={multiButtonSelect}
        setMultiButtonSelect={setMultiButtonSelect}
      />

      {multiButtonSelect == "Sound List" && <SoundList />}
      {multiButtonSelect == "Sound Category" && <SoundCategory />}
    </div>
  );
}
